export default {
  zip: null,
  addr: null,
  neighborhood: null,
  number: null,
  complement: null,
  city: null,
  state: null,
}